import { PRODUCT_TYPES, productTypes } from '@core/classes/Enums';
import FIMenu from '@core/classes/FIMenu';
import { DealKind } from '@core/classes/SharedEnums';
import request from '@core/services/request';
import settings from 'settings';

export const fimenuAPI = {
	//GETS
	getTotalDealsThatNeedAttention: (storeCodes: string[]) => {
		return request.post(`/FIMenu/GetTotalDealsThatNeedAttention`, storeCodes);
	},
	isDealUpToDate: (fimenuId: any, lastModifiedDate: any) => request.get(`/FIMenu/IsDealUpToDate?fimenuId=${fimenuId}&lastModifiedDate=${lastModifiedDate}`),
	getDeal: (id: any, type = DealKind.Deal) => request.get(`/FIMenu/GetFIMenuDealById?id=${id}&type=${type}`, { cache: false }),
	getLatestDeal: (id: any) => request.get(`/FIMenu/GetLatestFIMenuDeal?id=${id}`, { cache: false }),
	getDealByStoreCodeAndDealNumber: (storeCode: any, dealNumber: any) => request.get(`/FIMenu/GetFIMenuDealByStoreCodeAndDealNumber/${storeCode}/${dealNumber}`),
	getDealByDealNumber: (dealNumber: string) => request.get(`/FIMenu/GetFIMenuDealByDealNumber?dealNumber=${dealNumber}`),
	getEmptyPaperworkDocumentModel: () => request.get(`/FIMenu/GetDealPaperworkDocumentModel`),
	getDealPaperworkDocumentModel: (dealNumber: any, loadDealFromProd = false, isDealAQuote = false) =>
		request.get(`/FIMenu/GetDealPaperworkDocumentModel?dealNumber=${dealNumber}&loadDealFromProd=${loadDealFromProd}&isDealAQuote=${isDealAQuote}`),
	getFinanceChannelsModel: (dealNumber: any, loadDealFromProd = false, isDealAQuote = false) =>
		request.get(`/FIMenu/GetFinanceChannelsModel?dealNumber=${dealNumber}&loadDealFromProd=${loadDealFromProd}&isDealAQuote=${isDealAQuote}`),
	getPartnerCodeModel: (dealNumber: any, loadDealFromProd = false, isDealAQuote = false) =>
		request.get(`/FIMenu/GetPartnerCodeModel?dealNumber=${dealNumber}&loadDealFromProd=${loadDealFromProd}&isDealAQuote=${isDealAQuote}`),
	testDealDocs: (fimenu: any, documentToGenerateDetails: any) => request.post(`/Utilities/TestDealDocs`, { fimenu, documentToGenerateDetails, forceInternal: true }),
	getBuyersOrderModel: (dealNumber?: any) => request.post(`/FIMenu/GetBuyersOrderModel`, { dealNumber }),
	getEmptyLenderExpressionModel: () => {
		return request.get(`/FIMenu/GetLenderExpressionModel`);
	},
	getLenderExpressionModel: (dealNumber: any) => {
		return request.get(`/FIMenu/GetLenderExpressionModel?dealNumber=${dealNumber}`);
	},
	getEmptySettingsDocumentModel: () => request.get(`/FIMenu/GetSettingsDocumentModel`),
	getSettingsDocumentModel: (dealNumber: any, loadDealFromProd: any) =>
		request.get(`/FIMenu/GetSettingsDocumentModel?dealNumber=${dealNumber}&loadDealFromProd=${loadDealFromProd}`),
	getEmptyCancelDocumentModel: () => request.get(`/FIMenu/GetCancelDocumentModel`),
	getCancelDocumentModel: (dealNumber: any) => request.get(`/FIMenu/GetCancelDocumentModel?dealNumber=${dealNumber}`),
	getChecklistDocumentModel: (dealNumber: string = null, loadDealFromProd: boolean = false) =>
		request.get(`/FIMenu/GetChecklistDocumentModel?loadDealFromProd=${loadDealFromProd}&dealNumber=${dealNumber ?? ''}`),
	getELeadExpressionModel: (dealNumber: any) => request.get(`/FIMenu/GetELeadExpressionModel?dealNumber=${dealNumber ?? ''}`),
	createNewDealNumberBuyersOrder: (storeCode: any) => request.getSpecial(`/FIMenu/GetNextDealNumber/${storeCode}`),
	checkIfDealExistsGlobal: (dealNumber: any) => request.get(`/FIMenu/CheckIfDealExistsGlobal/${dealNumber}`),
	checkIfDealExists: (dealNumber: any, storeCode: any) => request.get(`/FIMenu/CheckIfDealExists/${storeCode}/${dealNumber}`),
	getDealsByVIN: (vin: any) => request.get(`/FIMenu/GetFIMenuDealsByVIN/` + vin),
	getDocument: (filePath: any) => {
		return request.get(`/FIMenu/GetDocument?filePath=${filePath}`);
	},
	getPaperworkDirectory: (path: any) => {
		return request.get(`/FIMenu/GetPaperworkDirectory?path=${path}`);
	},
	getAvailableProducts: (dealType: any) => {
		return new Promise((resolve, reject) => {
			const products = productTypes.filter(product => {
				if (product.hidden) return false;
				if (product.code === PRODUCT_TYPES.GAP && dealType !== 'Finance') return false;
				if (product.code === PRODUCT_TYPES.EXCESS_WEAR_AND_TEAR && dealType !== 'Lease') return false;

				return true;
			});

			resolve(products);
		});
	},
	//getCarFaxHTML: () => request.get(`/FIMenu/GetCarFaxHTML`),
	//SETS
	createNewDeal: (fimenu: any, saveDealCreation = false) => request.post(`/FIMenu/CreateNewDeal?saveDealCreation=${saveDealCreation}`, fimenu),
	saveDeal: (fimenu: any) =>
		request.post(`/FIMenu/Save`, {
			deal: fimenu,
			fraudCheckDayCount: settings.lookups.fraudCheckDayCount,
			fraudReCheckTimeInMin: settings.lookups.fraudReCheckTimeInMin,
		}),
	getDocumentsToGenerate: (fimenu: any, filter = false) => {
		return request.post(`/FIMenu/GetDocumentsToGenerate`, {
			fimenu,
			filterAlreadyExistingDocuments: filter,
		});
	},
	generateDocument: (fimenu: any, DocumentToGenerateDetails: any, forceInternal: any) => {
		return request.post(`/FIMenu/GenerateDocument`, {
			fimenu,
			DocumentToGenerateDetails,
			forceInternal,
		});
	},
	getLastestDocConfig: (fimenu: any, id: any, modelId: any) => {
		return request.post(`/FIMenu/GetLastestDocConfig`, {
			fimenu,
			id,
			modelId,
		});
	},
	getPaperwork: (fimenu: any, lender?: any) => {
		return request.post(`/FIMenu/GetPaperwork`, fimenu);
	},
	activatePaperwork: (activatePaperworkRequest: any) => {
		return request.post(`/FIMenu/ActivatePaperwork`, activatePaperworkRequest);
	},
	voidPaperwork: (fimenu: any, isNonApi = false) => {
		return request.post(`/FIMenu/VoidPaperwork?id=${fimenu.id}&isNonApi=${isNonApi}`, {});
	},
	saveUpdatedPaperwork: (dealId: any, docIds: any, currentSigner: any, paperwork: any) =>
		request.post(`/FIMenu/SaveUpdatedPaperwork`, {
			dealId,
			currentSigner,
			docIds,
			paperwork,
		}),
	uploadSignedPaperwork: (dealId: any, documentId: any, formData: any) => request.post(`/FIMenu/UploadSignedPaperwork/${dealId}/${documentId}`, formData),
	saveCurrentSignaturesAndInitialsToAzure: (uploadSignatureInitialsRequest: any) =>
		request.post(`/FIMenu/SaveCurrentSignaturesAndInitialsToAzure`, uploadSignatureInitialsRequest),
	upsertCustomerDocument: (form: any) => request.post(`/FIMenu/UpsertCustomerDocument`, form),
	deleteCustomerDocument: (azureFilepath: any, elasticId: any) =>
		request.post(`/FIMenu/DeleteCustomerDocument`, {
			azureFilepath,
			elasticId,
		}),
	getProductsRates: (fimenu: any, store: any, tokenId: any) => {
		return request.post(`/FIMenu/GetProductsRates`, { fimenu, store, providers: settings.lookups.providers }, { cancelToken: request.getCancellationToken(tokenId) });
	},
	getProductsPrice: (fimenu: any, store: any, products: any, priceProducts: any) => {
		return request.post(`/FIMenu/GetProductsPrice`, {
			fimenu,
			store,
			products,
			providers: settings.lookups.providers,
			priceProducts,
		});
	},
	deleteDeal: (deleteDealRequest: any) => {
		return request.post(`/FIMenu/DeleteDeal`, deleteDealRequest);
	},
	getDealsPaged: (dealsRequest: any) => {
		return request.post(`/FIMenu/GetFIMenuDealsPaged`, dealsRequest);
	},
	submitDailySales: (storeCode: string, submitDateDay: Date) => {
		return request.post(`/FIMenu/SubmitDailySales`, {
			storeCode,
			submitDateDay,
		});
	},
	sendDailySalesMessage: (storeCodes: string[], submitDateDay: Date) => {
		return request.post(`/FIMenu/SendDailySalesMessage`, {
			storeCodes,
			submitDateDay,
		});
	},
	downloadDailySalesSubmission: (storeCodes: string[], submitDateDay: Date, isTotalDownload: boolean = false) => {
		return request.downloadPost(`/FIMenu/DownloadDailySalesSubmission`, {
			storeCodes,
			submitDateDay,
			isTotalDownload,
		});
	},
	getDailySaleSubmitStatus: (storeCode: string, submitDateDay: Date) => {
		return request.post(`/FIMenu/GetDailySaleSubmitStatus`, {
			storeCode,
			submitDateDay,
		});
	},
	getDealsById: (idList: any) => {
		return request.post(`/FIMenu/GetFIMenuDealsById`, idList);
	},
	getDealIndexAutoFiltersByStore: (availableStoreCodes: any) => {
		return request.post(`/FIMenu/GetFIMenuAutoFiltersByStore`, availableStoreCodes);
	},
	//DOWNLOAD
	printPaymentSheet: (postData: any, fileName: any) => {
		return request.downloadPost(`/FIMenu/PrintPaymentSheet`, postData, fileName);
	},
	previewDocument: (paperworkDocumentPreviewRequest: any) => {
		return request.post('/FIMenu/PreviewDocument', paperworkDocumentPreviewRequest);
	},
	downloadDocument: (filePath: any, fileName: any) => {
		return request.download(`/FIMenu/DownloadDocument?filePath=${filePath}`, fileName);
	},
	getDocumentBytes: (filePath: any) => {
		return request.get(`/FIMenu/GetDocumentBytes?filePath=${filePath}`);
	},
	repopulateAndDownloadDocument: (filePath: any, fileName: any, dealId: any, uploadedFilePath: any) => {
		return request.download(
			`/FIMenu/RepopulateAndDownloadDocument?filePath=${filePath}&dealId=${dealId}&fileName=${fileName}&uploadedFilePath=${uploadedFilePath}`,
			fileName,
		);
	},
	repopulateAndDownloadDocuments: (dealId: any, packetSelectedDocuments: any, uploadedSelectedDocuments: any, forceRepopulate = false) => {
		return request.post(`/FIMenu/RepopulateAndDownloadDocuments?dealId=${dealId}`, {
			uploadedSelectedDocuments,
			packetSelectedDocuments,
			forceRepopulate,
		});
	},
	repopulateAndDownloadDocumentsSeparate: (dealId: any, packetSelectedDocuments: any, uploadedSelectedDocuments: any) => {
		return request.post(`/FIMenu/RepopulateAndDownloadDocumentsSeparate?dealId=${dealId}`, {
			uploadedSelectedDocuments,
			packetSelectedDocuments,
		});
	},
	customerDownloadDocument: (fileName: any, meetingCode: any, accessKey: any, dateStamp: any, userId: any) => {
		return request.getSB(
			`/SaturnWeb/CustomerDownloadDocument?fileName=${fileName}&meetingCode=${meetingCode}&accessKey=${accessKey}&dateStamp=${dateStamp}&userId=${userId}`,
		);
	},
	downloadAllDocuments: (dealNumber: any, storeCode: any, packetId: any, fileName: any) => {
		return request.download(`/FIMenu/DownloadAllDocuments?dealNumber=${dealNumber}&storeCode=${storeCode}&packetId=${packetId}`, fileName);
	},
	getBuyersOrder: (fiMenuBuyersOrderRequest: any) => {
		return request.post(`/FIMenu/GetBuyersOrder`, fiMenuBuyersOrderRequest);
	},
	getCarCalcsBuyersOrder: (fimenu: any) => request.post(`/FIMenu/CarCalcBuyersOrder`, fimenu),
	downloadCustomerDocument: (filePath: any, fileType: any, fileName: any) => {
		return request.download(`/FIMenu/DownloadCustomerDocument?filePath=${filePath}&fileType=${fileType}&fileName=${fileName}`, fileName);
	},
	getCustomersInfoFromDeal(dealsList: any[] = []) {
		return request.post(`/FIMenu/GetCustomerInfoFromDeal`, dealsList);
	},
	saveCustomers: (fimenu: any) => request.post(`/FIMenu/SaveCustomers`, fimenu),
	saveQuoteAndDeal: (fimenu: any) => request.post(`/FiMenu/saveQuoteAndDeal`, fimenu),
	requestInternalApprovalOTP: (deal: any) => request.post(`/FIMenu/RequestInternalApprovalOTP`, deal),
	getSummaryData: (fimenu: any) => request.post(`/FIMenu/GetSummaryData`, fimenu),
	getSessionInfo() {
		return request.post(`/FIMenu/GetSessionInfo`);
	},
	syncFunding: (fimenu: any, companyId: any) => request.post(`/FIMenu/SyncFunding`, { fimenu, companyId }),
	getExternalDMSDealData: (fimenu: FIMenu, getNew: boolean = false) => request.post(`/FIMenu/GetExternalDMSDealData`, { fimenu, getNew }),
};
